import * as React from 'react';
import { VerifyExternalUserProps } from '../types';

const VerifyExternalUser: React.FC<VerifyExternalUserProps> = ({ onComplete }) => {
  const [isVerifying, setIsVerifying] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleVerification = (): void => {
    setIsVerifying(true);
    setError(null);
    
    // Placeholder for One ID verification
    setTimeout(() => {
      try {
        // Simulate successful verification
        console.log("One ID verification successful");
        setIsVerifying(false);
        onComplete();
      } catch (err) {
        console.error("Verification failed:", err);
        setError("Verification failed. Please try again.");
        setIsVerifying(false);
      }
    }, 1500);
  };

  return (
    <div className="step-content">
      <h2>Verify Your External Access</h2>
      <p>We need to verify your identity with One ID to grant SharePoint access</p>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <button 
        className="primary-button"
        onClick={handleVerification}
        disabled={isVerifying}
      >
        {isVerifying ? 'Verifying...' : 'Verify with One ID'}
      </button>
    </div>
  );
};

export default VerifyExternalUser;